import { NyukyoStatus, PageID, RoomSb, TaikyoRiyuKb } from "~/extensions/utils/DefineTypes";
import { defineComponent, reactive, computed } from "vue";
import { api } from "~/api";
import { useRouter } from "vue-router";
import { Log } from "~/extensions/utils";
import { MsgBox } from "~/components/MsgBox";
import { store } from "../store/TaikyoStore";
import { myPageStore } from "~/store/MyPageStore";
import extend from 'quasar/src/utils/extend/extend.js';import Loading from 'quasar/src/plugins/loading/Loading.js';
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
import { store as taikyoStore } from "~/pages/taikyo/store/TaikyoStore";
import { commonStore } from "~/store/CommonStore";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import dayjs from "dayjs";
import { TaikyoEntryPageViewModel } from "./Models/TaikyoEntryPageViewModel";
import { updateKaiyakuYmd } from "../notification/Models/TaikyoFormHelper";
const log = Log.create("TaikyoEntryCheckPage");
export default defineComponent({
    components: {
        BreadcrumbList
    },
    name: "TaikyoEntryCheckPage",
    async beforeRouteEnter(to, from, next) {
        if (isNullOrUndefined(taikyoStore.taikyoEntity.status)) {
            await taikyoStore.load();
        }
        // ここは必要だと思う。申請中の場合は次画面
        if (taikyoStore.taikyoEntity.status === NyukyoStatus.Request) {
            next();
            return;
        }
        const fromScreen = from.name;
        const relatedScreens = ["taikyo-entry"];
        if (relatedScreens.includes(fromScreen) && store.privacyConsent) {
            next();
            return;
        }
        next({ name: "taikyo" });
    },
    async setup() {
        const router = useRouter();
        const nyukyokeiyaku = myPageStore.selectedNyukyokeiyaku;
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        const pageName = commonStore.pageName(PageID.taikyoEntryCheck);
        const personal = reactive(myPageStore.personal);
        const taikyo = reactive(store.taikyoEntity);
        const taikyoForInput = reactive(store.taikyoForInput);
        const taikyoEntryPageViwModel = new TaikyoEntryPageViewModel(store.taikyoEntity, myPageStore.selectedNyukyokeiyaku.roomSb);
        const isShinsei = taikyo.status === NyukyoStatus.CurrentlyMovingIn;
        const safe = (v) => v ?? ""; // null / undefined を '' にする
        const address = computed(() => [isNullOrUndefined(taikyo.postCode) ? "" : "〒" + safe(taikyo.postCode), safe(taikyo.adr1), safe(taikyo.adr2), safe(taikyo.adr3)].join("\n"));
        const initView = async () => {
            try {
                if (taikyo.status !== NyukyoStatus.CurrentlyMovingIn) {
                    extend(true, taikyoForInput, await api.taikyo.findForInput());
                }
                if (taikyo.status === NyukyoStatus.Request) {
                    //解約日算出処理
                    updateKaiyakuYmd(taikyo);
                }
            }
            catch (ex) {
                log.error("find", ex);
                MsgBox.error(ex.message);
            }
        };
        const back = () => {
            if (taikyo.status === 0) {
                router.back();
            }
            else {
                router.push({ name: "taikyo-room-list" });
            }
        };
        const apply = async () => {
            try {
                Loading.show();
                store.setData(taikyo, taikyoForInput);
                await store.insert();
                await router.push({ name: "taikyo-entry-complete" });
                store.clear();
                // 個人情報ストアのロード
                myPageStore.load();
                await myPageStore.waitForBasic();
            }
            catch (ex) {
                MsgBox.error(ex?.message ?? "エラーが発生しました。");
                if (ex?.data !== null && ex?.data?.code === "error.mail") {
                    router.push({ name: "taikyo-entry-complete" });
                }
            }
            finally {
                Loading.hide();
            }
        };
        initView();
        return {
            personal,
            router,
            nyukyokeiyaku,
            taikyo,
            apply,
            taikyoForInput,
            taikyoEntryPageViwModel,
            dayjs,
            movingServicesList: [
                { label: "同意します", value: 1 },
                { label: "同意しません", value: 0 }
            ],
            store,
            address,
            myPageStore,
            RoomSb,
            isMultipleKeiyaku,
            back,
            pageName,
            PageID,
            isShinsei,
            TaikyoRiyuKb,
            NyukyoStatus
        };
    }
});
